import Vue from 'vue';
import LogRocket from 'logrocket';
import firebase from "firebase/app";
import App from './App.vue';
import NoApp from './NoApp.vue';
import store from './store';
import vuetify from './plugins/vuetify';
import router from './router';
import getLocation from "./utils/get-location";
import appConfig from "../application-configuration";

Vue.config.productionTip = false;
import 'leaflet/dist/leaflet.css';

firebase.initializeApp(appConfig.firebase);

if (location.hostname !== 'localhost') {
  LogRocket.init('6cbvkc/luke-lights');
}

let skipLocation = false;

// ? This has been hacked together as a quite way to let users who scan the QR code skip location checking altogether
// ? I'm repurposing the query string code functionality for remote access, but that can be further worked into this
// ? pattern next time I run a remote night
if (location.search !== '') {
  const params = new URLSearchParams(location.search);
  const codeParam = params.toString().replace('=', '');
  if (codeParam === 'tmpQr') {
    skipLocation = true;
    store.dispatch('SET_IS_LOCAL', { isLocal: true });
  }

  // ? Essentially trying to future proof when I might want to have dynamically changing codes through the QR or similar
  if (codeParam) {
    store.dispatch('SET_CODE', { code: codeParam });
  }

  window.history.replaceState({}, document.title, location.pathname);

  // Save the code to localStorage. It will be used in the get-location utility in place of actually getting location
  // localStorage.setItem('queryStringCode', params.toString().replace('=', ''));
  // store.dispatch('SET_IS_REMOTE', { isRemote: true });
}


const geolocationAvailable = 'geolocation' in navigator;
if (!geolocationAvailable && !skipLocation) {
  // User doesn't have the ability to get geolocation from their device, so they can't access the control panel for the lights
  // Annoyingly I've had to double up this mounting code, even though the only difference is `NoApp` vs `App` because I have
  // to make an asynchronous call to request access to the users location
  new Vue({
    store,
    vuetify,
    router,
    render: h => h(NoApp),
    propsData: {
      oldDevice: true
    }
  }).$mount('#app');

} else {
  if (skipLocation) {
    new Vue({
      store,
      vuetify,
      router,
      render: h => h(App)
    }).$mount('#app');
  } else {
    getLocation()
      .then(() => {
        new Vue({
          store,
          vuetify,
          router,
          render: h => h(App)
        }).$mount('#app');
      })
      .catch(() => {
        new Vue({
          store,
          vuetify,
          router,
          render: h => h(NoApp)
        }).$mount('#app');
      });

  }


}


